import React, { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { twMerge } from 'tailwind-merge';

type RootPortalProps = {
  children: ReactNode;
  className?: string;
};

export const RootPortal: FC<RootPortalProps> = ({ children, className }) => {
  const modalRoot = document.getElementById('modal');
  if (!modalRoot) return null;

  return ReactDOM.createPortal(
    <div
      className={twMerge(
        'fixed inset-0 z-[99999] flex h-screen min-h-full w-screen min-w-full items-center justify-center',
        className,
      )}
    >
      {children}
    </div>,
    modalRoot,
  );
};
